// extracted by mini-css-extract-plugin
export default {"stellarAddressContainer":"Hk0tTSN9YU8WTUrsWIga"};